/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/prefer-default-export */

import { createPortal } from 'react-dom'
import React, { useState } from 'react'
import clsx from 'clsx'
import s from './ManageCollection.module.css'

import { GeneralSettings } from './components/GeneralSettings'
import { Collaborators } from './components/Collaborators'
import { CoverImage } from './components/CoverImage'
import { Listings } from './components/Listings'

export function ManageCollection({ onClose, id }) {
  const [activeTabId, setActiveTabId] = useState(1)

  const TABS = [
    {
      id: 1,
      label: 'General Settings',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <g clipPath="url(#clip0_13_479)">
            <path
              d="M8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38071 5.5 8 5.5C6.61929 5.5 5.5 6.61929 5.5 8C5.5 9.38071 6.61929 10.5 8 10.5Z"
              stroke="#ECECEC"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.58934 11.1306C2.31307 10.6547 2.10142 10.1442 1.95996 9.61246L3.00871 8.29996C2.99684 8.0993 2.99684 7.89812 3.00871 7.69746L1.96059 6.38496C2.1018 5.85313 2.31302 5.34242 2.58871 4.86621L4.25809 4.67871C4.39139 4.52852 4.53352 4.38639 4.68371 4.25309L4.87121 2.58434C5.34674 2.30996 5.85662 2.09999 6.38746 1.95996L7.69996 3.00871C7.90062 2.99684 8.1018 2.99684 8.30246 3.00871L9.61496 1.96059C10.1468 2.1018 10.6575 2.31302 11.1337 2.58871L11.3212 4.25809C11.4714 4.39139 11.6135 4.53352 11.7468 4.68371L13.4156 4.87121C13.6919 5.34706 13.9035 5.85759 14.045 6.38934L12.9962 7.70184C13.0081 7.90249 13.0081 8.10368 12.9962 8.30434L14.0443 9.61684C13.9041 10.1485 13.6939 10.6592 13.4193 11.1356L11.75 11.3231C11.6167 11.4733 11.4745 11.6154 11.3243 11.7487L11.1368 13.4175C10.661 13.6937 10.1505 13.9054 9.61871 14.0468L8.30621 12.9981C8.10555 13.01 7.90437 13.01 7.70371 12.9981L6.39121 14.0462C5.85954 13.906 5.34883 13.6958 4.87246 13.4212L4.68496 11.7518C4.53477 11.6185 4.39264 11.4764 4.25934 11.3262L2.58934 11.1306Z"
              stroke="#ECECEC"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_13_479">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      content: <GeneralSettings id={id} />,
    },
    {
      id: 2,
      label: 'Collaborators',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <g clipPath="url(#clip0_25_1504)">
            <path d="M12.5 8.5H15.5" stroke="#ECECEC" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14 7V10" stroke="#ECECEC" strokeLinecap="round" strokeLinejoin="round" />
            <path
              d="M6.75 10C8.82107 10 10.5 8.32107 10.5 6.25C10.5 4.17893 8.82107 2.5 6.75 2.5C4.67893 2.5 3 4.17893 3 6.25C3 8.32107 4.67893 10 6.75 10Z"
              stroke="#ECECEC"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1.5 12.5C2.78437 10.9719 4.5975 10 6.75 10C8.9025 10 10.7156 10.9719 12 12.5"
              stroke="#ECECEC"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_25_1504">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      content: <Collaborators id={id} />,
    },

    {
      id: 3,
      label: 'Cover Image',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <g clipPath="url(#clip0_13_491)">
            <path
              d="M13.5 3H2.5C2.22386 3 2 3.22386 2 3.5V12.5C2 12.7761 2.22386 13 2.5 13H13.5C13.7761 13 14 12.7761 14 12.5V3.5C14 3.22386 13.7761 3 13.5 3Z"
              stroke="#ECECEC"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.75 7C10.1642 7 10.5 6.66421 10.5 6.25C10.5 5.83579 10.1642 5.5 9.75 5.5C9.33579 5.5 9 5.83579 9 6.25C9 6.66421 9.33579 7 9.75 7Z"
              fill="#ECECEC"
            />
            <path
              d="M9.20703 10.2501L10.8127 8.64633C10.9064 8.55263 11.0335 8.5 11.1661 8.5C11.2986 8.5 11.4258 8.55263 11.5195 8.64633L14.0002 11.1288"
              stroke="#ECECEC"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2 10.543L5.39625 7.14615C5.44269 7.09967 5.49783 7.06279 5.55853 7.03763C5.61923 7.01246 5.68429 6.99951 5.75 6.99951C5.81571 6.99951 5.88077 7.01246 5.94147 7.03763C6.00217 7.06279 6.05731 7.09967 6.10375 7.14615L11.9569 12.9999"
              stroke="#ECECEC"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_13_491">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      content: <CoverImage id={id} />,
    },
    {
      id: 4,
      label: 'Listings',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <g clipPath="url(#clip0_13_491)">
            <path
              d="M13.5 3H2.5C2.22386 3 2 3.22386 2 3.5V12.5C2 12.7761 2.22386 13 2.5 13H13.5C13.7761 13 14 12.7761 14 12.5V3.5C14 3.22386 13.7761 3 13.5 3Z"
              stroke="#ECECEC"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.75 7C10.1642 7 10.5 6.66421 10.5 6.25C10.5 5.83579 10.1642 5.5 9.75 5.5C9.33579 5.5 9 5.83579 9 6.25C9 6.66421 9.33579 7 9.75 7Z"
              fill="#ECECEC"
            />
            <path
              d="M9.20703 10.2501L10.8127 8.64633C10.9064 8.55263 11.0335 8.5 11.1661 8.5C11.2986 8.5 11.4258 8.55263 11.5195 8.64633L14.0002 11.1288"
              stroke="#ECECEC"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2 10.543L5.39625 7.14615C5.44269 7.09967 5.49783 7.06279 5.55853 7.03763C5.61923 7.01246 5.68429 6.99951 5.75 6.99951C5.81571 6.99951 5.88077 7.01246 5.94147 7.03763C6.00217 7.06279 6.05731 7.09967 6.10375 7.14615L11.9569 12.9999"
              stroke="#ECECEC"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_13_491">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      content: <Listings id={id} />,
    },
  ]

  const currentContent = TABS.find((tabItem) => tabItem.id === activeTabId)?.content

  return createPortal(
    <>
      <div className={s.overlay} />
      <div className={s.root}>
        <div className={s.sidebar}>
          <div className={s.sidebarTitle}>Manage Collection</div>

          <div className={s.sidebarTabs}>
            {TABS.map((tabItem) => (
              <div
                onClick={() => setActiveTabId(tabItem.id)}
                key={tabItem.id}
                className={clsx(s.sidebarTab, tabItem.id === activeTabId && s.sidebarTabActive)}
              >
                {tabItem.icon} {tabItem.label}
              </div>
            ))}
          </div>
        </div>

        <div className={s.divider} />

        <div className={s.content}>
          {currentContent}

          <div className={s.close} onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path
                d="M17.6738 16.701C17.7377 16.7649 17.7883 16.8407 17.8229 16.9242C17.8575 17.0076 17.8753 17.0971 17.8753 17.1874C17.8753 17.2777 17.8575 17.3672 17.8229 17.4506C17.7883 17.5341 17.7377 17.6099 17.6738 17.6738C17.6099 17.7377 17.5341 17.7883 17.4506 17.8229C17.3672 17.8575 17.2777 17.8753 17.1874 17.8753C17.0971 17.8753 17.0076 17.8575 16.9242 17.8229C16.8407 17.7883 16.7649 17.7377 16.701 17.6738L10.9999 11.9718L5.2988 17.6738C5.1698 17.8028 4.99483 17.8753 4.81239 17.8753C4.62996 17.8753 4.45499 17.8028 4.32599 17.6738C4.19698 17.5448 4.12451 17.3698 4.12451 17.1874C4.12451 17.005 4.19698 16.83 4.32599 16.701L10.0279 10.9999L4.32599 5.2988C4.19698 5.1698 4.12451 4.99483 4.12451 4.81239C4.12451 4.62996 4.19698 4.45499 4.32599 4.32599C4.45499 4.19698 4.62996 4.12451 4.81239 4.12451C4.99483 4.12451 5.1698 4.19698 5.2988 4.32599L10.9999 10.0279L16.701 4.32599C16.83 4.19698 17.005 4.12451 17.1874 4.12451C17.3698 4.12451 17.5448 4.19698 17.6738 4.32599C17.8028 4.45499 17.8753 4.62996 17.8753 4.81239C17.8753 4.99483 17.8028 5.1698 17.6738 5.2988L11.9718 10.9999L17.6738 16.701Z"
                fill="currentColor"
              />
            </svg>
          </div>
        </div>
      </div>
    </>,
    document.body
  )
}
